import { Box, Button, Typography } from '@mui/material';

import ImagemErro from '../../../assets/erro-pagamento.svg';
import { Colors } from '../../../shared/colors';

interface Props {
  onPaymentFailed: () => void;
  erroMsg?: string | null;
}

const PagamentoRecusado = ({ onPaymentFailed, erroMsg }: Props) => {
  return (
    <Box flex={1} display="flex" flexDirection="column" justifyContent="space-between">
      <Box
        display="flex"
        px={{ xs: 2, md: 5 }}
        py={{ xs: 5, md: 10 }}
        flexDirection="column"
        alignItems="center"
      >
        <Typography color="secondary" variant="h6" fontWeight="bold">
          Algo deu errado!
        </Typography>
        <Typography
          mt={2}
          variant="body1"
          fontSize={{ xs: '1rem', sm: '1.5rem' }} // Ajuste da fonte para tamanhos menores em telas pequenas
          textAlign="center"
          color={Colors.gray1}
        >
          {erroMsg ||
            'Sua transação não foi finalizada! Para tentar novamente clique no botão abaixo.'}
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        flex={1}
        px={{ xs: 2, md: 5 }}
        py={{ xs: 5, md: 10 }}
      >
        <img
          src={ImagemErro}
          alt="pagamento_realizado"
          style={{ maxWidth: '50%', height: 'auto' }}
        />
      </Box>

      <Box display="flex" justifyContent="center" pb={{ xs: 2, md: 5 }}>
        <Button fullWidth variant="contained" onClick={onPaymentFailed}>
          <Typography textTransform="none">Voltar à tela de pagamento</Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default PagamentoRecusado;
